import * as bowser from 'bowser';

type BowserStatic = typeof import('bowser');

/**
 * bowser は CJS。Nitro の externals 経路では `import Bowser from 'bowser'` が
 * 名前空間のまま残り、`getParser` / `OS_MAP` が undefined になる。
 *
 * `.default` を直接読むと webpack が interop ヘルパへ書き換えるため、
 * unknown 経由で剥がす。ユニットテストはこの経路を通らない。
 */
const loaded: unknown = bowser;

export const Bowser: BowserStatic =
  (loaded as { default?: BowserStatic }).default ?? (loaded as BowserStatic);
